import { where } from 'firebase/firestore';
import { unitsOf } from './permissions';

// Messages and Archives are read unit by unit (Firestore rules): each entry carries `units` and
// a query asks only for the entries of the account's units; the administration reads them all.
// Returns the query constraints, or null when the account has no unit (nothing to read).
export const unitConstraints = (user) => {
  if (user && user.role === 'Admin') return [];
  const units = unitsOf(user && user.service);
  return units.length ? [where('units', 'array-contains-any', units)] : null;
};
